import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import CanvasReaderForm from '../forms/canvas-reader-form';
import { canvasReaderValidationSchema } from '../schema/canvasReader.js';

export default function CanvasReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Canvas Reader Node Details',
        altText: 'Canvas Reader Node',
        defaultLabel: 'Canvas Reader Node',
      }}
    >
      <CommonNode FormComponent={CanvasReaderForm} schemaResolver={canvasReaderValidationSchema} />
    </NodeProvider>
  );
}
